export default "__VITE_ASSET__DPeKB8eJ__"